<template>
  <div v-if="displayItems.length" class="ticker-banner">
    <div class="ticker-placeholder" aria-hidden="true" />
    <div class="ticker-wrap">
      <div class="ticker-track">
        <span
          v-for="(item, index) in displayItems"
          :key="`${item}-${index}`"
          class="ticker-item"
        >
          {{ item }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tickerItems: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    displayItems() {
      if (!this.tickerItems.length) {
        return [];
      }
      return [...this.tickerItems, ...this.tickerItems];
    },
  },
};
</script>

<style lang="scss" scoped>
$ticker-height: 74px;
$header-height: 160px;

.ticker-placeholder {
  height: $ticker-height;
}

.ticker-wrap {
  position: fixed;
  top: $header-height;
  left: 0;
  right: 0;
  z-index: 98;
  height: $ticker-height;
  padding: 24px 0;
  box-sizing: border-box;
  background-color: rgba($color: #000, $alpha: 0.5);
  backdrop-filter: blur(10px);
  overflow: hidden;
}

.ticker-track {
  display: flex;
  white-space: nowrap;
  animation: ticker-scroll 20s linear infinite;
}

.ticker-item {
  flex-shrink: 0;
  padding: 0 24px;
  font-size: 26px;
  line-height: 26px;
  color: #fff;
}

@keyframes ticker-scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}
</style>
